import { EfsMelcoEfsModelsFormat } from "melco-shared-logic";

export const useDesignMappingDataAssignments = (
  inputFormat: EfsMelcoEfsModelsFormat | undefined
) => {
  return inputFormat?.schema_list ?? [];
};
